import { Component, type ReactNode } from "react";

interface Props { name: string; children: ReactNode; fallback?: ReactNode }
interface State { hasError: boolean; error?: Error }

/**
 * SectionBoundary — isolates a UI section so a render-time crash never
 * collapses the surrounding route. Pair with route-level errorComponent.
 */
export class SectionBoundary extends Component<Props, State> {
  state: State = { hasError: false };
  static getDerivedStateFromError(error: Error): State { return { hasError: true, error }; }
  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error(`[SectionBoundary:${this.props.name}]`, error);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback !== undefined) return this.props.fallback;
    return (
      <div className="rounded-lg border border-dashed border-border bg-muted/30 px-3 py-2 text-[11px] text-muted-foreground">
        ⚡ Ajustando experiencia en tiempo real…
      </div>
    );
  }
}
